// extracted by mini-css-extract-plugin
module.exports = {"customDropArea":"customDropArea__rJjl4","content":"content__sQlE1","title":"title__GcmDl","info":"info__Jbu54","fileTypes":"fileTypes__lFMjM"};